import { chakra, Tag } from "@chakra-ui/react";

export default function PatientOutsourcingInfoBar() {
  return <BaseTag colorScheme="blue">⚠️ This is an Outsourcing Patient ⚠️</BaseTag>;
}

const BaseTag = chakra(Tag, {
  baseStyle: {
    padding: 3,
    lineHeight: 1.5,
  },
});
